import { composeValidators } from 'components/Form/validate';
import { Message } from 'models';
import React, { ChangeEventHandler, ReactNode } from 'react';
import { Field } from 'react-final-form';
import { v4 as uuid } from 'uuid';

import { ChoiceError } from '../ChoiceError';
import { RadioButton } from './RadioButton';

interface RadioProps {
  name: string;
  options: {
    value: string;
    label: string | ReactNode;
    id?: string;
    sublabel?: string;
    disabled?: boolean;
    section?: ReactNode;
  }[];
  id?: string;
  validate?: Array<(inputValue: unknown) => undefined | Message>;
  disabled?: boolean;
  direction?: 'column' | 'column-reverse' | 'row' | 'row-reverse';
  onChange?: ChangeEventHandler<HTMLInputElement>;
  testid?: string;
  className?: string;
  sublabelIsLink?: boolean;
}

export class Radio extends React.Component<RadioProps> {
  onFieldChange = (e: React.ChangeEvent<HTMLInputElement>, FFonFieldChange: ChangeEventHandler<HTMLInputElement>) => {
    FFonFieldChange(e);
    if (typeof this.props.onChange === 'function') this.props.onChange(e);
  };

  render() {
    const { name, options, validate, disabled, testid, className, sublabelIsLink } = this.props;
    // Random ID is generated if id is not set (this way labels will stay accessible).
    const id = this.props.id || uuid();

    return (
      <>
        {options.map((option, index) => (
          <>
            {option.section}
            <Field
              key={index}
              name={name}
              type="radio"
              value={option.value}
              validate={validate && !disabled ? composeValidators(validate) : undefined}
              render={({ input }) => (
                <RadioButton
                  id={`${id}_${index}`}
                  data-testid={testid}
                  {...input}
                  onChange={(e) => this.onFieldChange(e, input.onChange)}
                  disabled={disabled || option.disabled}
                  // @ts-expect-error TS(2322): Type 'ReactNode' is not assignable to type 'string... Remove this comment to see the full error message
                  label={option.label}
                  sublabel={option.sublabel}
                  sublabelIsLink={sublabelIsLink}
                  className={className}
                />
              )}
            />
          </>
        ))}
        <ChoiceError name={name} />
      </>
    );
  }
}
